import { Component, forwardRef, Input, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ColumnFilter } from '@check-list/app/classes/models/column-filter.model';

@Component({
  selector: 'authority-labs-column-filter',
  templateUrl: './column-filter.component.html',
  styleUrls: ['./column-filter.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ColumnFilterComponent),
      multi: true
    }
  ]
})
export class ColumnFilterComponent implements ControlValueAccessor {
  @Input() filters: ColumnFilter[] = [];

  private activeFilters: ColumnFilter[] = [];
  private _onTouchedCallback: () => unknown;
  private _onChangeCallback: (_: unknown) => unknown;

  toggle(filter: ColumnFilter): void {
    if (this.isChecked(filter)) {
      this.activeFilters = this.activeFilters.filter((x) => x !== filter);
    } else {
      this.activeFilters.push(filter);
    }
    this._onChangeCallback(this.activeFilters);
    this._onTouchedCallback();
  }

  isChecked(filter: ColumnFilter): boolean {
    return !!this.activeFilters.find((x) => x.label === filter.label);
  }

  writeValue(value: ColumnFilter[]) {
    this.activeFilters = value || [];
  }

  registerOnChange(fn: () => unknown) {
    this._onChangeCallback = fn;
  }

  registerOnTouched(fn: () => unknown) {
    this._onTouchedCallback = fn;
  }
}
